module.exports = __webpack_public_path__ + "img/AstroFrens190.b1e0f301.jpg";